import React from "react";

/**
 * RealImage — renders a real image inside a futuristic technological frame.
 * Preserves aspect ratio (object-cover for fills, object-contain for logos).
 */
export default function RealImage({
  src,
  alt = "",
  ratio = "16/9",
  fit = "cover",
  className = "",
  frameless = false,
  testId,
  padded = false,
  bg = "#020815",
}) {
  const content = (
    <div className="relative w-full h-full overflow-hidden" style={{ background: bg }}>
      <img
        src={src}
        alt={alt}
        className={`w-full h-full ${padded ? "p-4 md:p-6" : ""}`}
        style={{ objectFit: fit }}
        loading="lazy"
      />
      {!frameless && (
        <>
          {/* Corner marks */}
          <span className="absolute top-2 left-2 w-3 h-3 border-t border-l border-[#e77300] opacity-80" />
          <span className="absolute top-2 right-2 w-3 h-3 border-t border-r border-[#e77300] opacity-80" />
          <span className="absolute bottom-2 left-2 w-3 h-3 border-b border-l border-[#e77300] opacity-80" />
          <span className="absolute bottom-2 right-2 w-3 h-3 border-b border-r border-[#e77300] opacity-80" />
          {/* Top scan line */}
          <span className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#005fca] to-transparent opacity-70" />
        </>
      )}
    </div>
  );

  return (
    <div
      data-testid={testId}
      className={`relative border border-[#005fca]/40 hover:border-[#e77300]/70 transition-colors duration-500 ${className}`}
      style={{ aspectRatio: ratio, background: bg }}
    >
      {content}
    </div>
  );
}
